import Swiper from 'swiper/dist/js/swiper.js';

const mainSwiper = new Swiper('.swiper-container--main', {
	spaceBetween: 30,
	effect: 'fade',
	loop: true,
	speed: 900,
	parallax: true,
	simulateTouch: false,
	pagination: {
		el: '.swiper-pagination--main',
		clickable: true,
		type: 'bullets',
		renderBullet: function (index, className) {
			let $slide = $(this.slides[index+1]),
					title = $slide.data('title'),
					linkText = $slide.data('link-text'),
					linkHref = $slide.data('link-href');
			return `
				<div class="${className}">
					<span class="${className}__title">${title}</span>
					<a href="${linkHref}" class="${className}__link">${linkText}</a>
				</div>`;
		}
	},
	navigation: {
		nextEl: '.swiper-button-next--main',
		prevEl: '.swiper-button-prev--main',
	}
});


$(document).on('click', '.swiper-pagination-bullet__link', function() {
	window.location = $(this).attr('href');
});

mainSwiper.on('slideChangeTransitionStart', function () {
	let $prevSlide = $(this.slides[this.realIndex]);
	$('.swiper-container--main')
		.find('.swiper-navigation')
		.velocity('stop')
		.velocity('fadeOut', {
			duration: 0,
			easing: 'linear'
		});
	$('.slide__line-3')
		.velocity({
			'left': '100%'
		}, {
			duration: 0,
			easing: 'linear',
			begin: function () {
				$(this).hide();
			},
			complete: function () {
			}
		});
	$('.slide__line-2')
		.velocity({
			'top': '100%'
		}, {
			duration: 0,
			easing: 'linear',
			begin: function () {
				$(this).hide();
			},
			complete: function () {
			}
		});
	$('.slide__line-1')
		.velocity({
			'width': '0rem'
		}, {
			duration: 0,
			easing: 'linear',
			begin: function () {
				$(this).hide();
			},
			complete: function () {
			}
		});
});

mainSwiper.on('slideChangeTransitionEnd', function () {
	let $currentSlide = $(this.slides[this.activeIndex]);
	$currentSlide
		.find('.slide__line-3')
		.velocity({
			'left': '0%'
		}, {
			duration: 200,
			easing: 'linear',
			begin: function () {
				$(this).show();
			},
			complete: function () {
			}
		});
	$currentSlide
		.find('.slide__line-2')
		.velocity({
			'top': '0%'
		}, {
			delay: 200,
			duration: 200,
			easing: 'linear',
			begin: function () {
				$(this).show();
			},
			complete: function () {
			}
		});
	$currentSlide
		.find('.slide__line-1')
		.velocity({
			'width': '11.5rem'
		}, {
			delay: 400,
			duration: 200,
			easing: 'linear',
			begin: function () {
				$(this).show();
			},
			complete: function () {
			}
		});
	$('.swiper-container--main')
		.find('.swiper-navigation')
		.velocity('stop')
		.velocity('fadeIn', {
			delay: 600,
			duration: 200,
			easing: 'linear'
		});
});

// TEAM SLIDER MAINPAGE
const teamSwiper = new Swiper('.swiper-container--team:not(.team)', {
	spaceBetween: 22,
	slidesPerView: 2,
	scrollbar: {
		el: '.swiper-scrollbar--team',
		hide: false,
	},
	navigation: {
		nextEl: '.swiper-button-next--team',
		prevEl: '.swiper-button-prev--team',
	},
	breakpoints: {
		520: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 2,
		},
		1024: {
			slidesPerView: 1,
		}
	}
});

// TEAM SLIDER MAINPAGE

// if ($('.our-team').length) {
// 	let hashSlide = 0;

// 	if (location.hash.length) {
// 		let hash = location.hash,
// 			arIds = $('.team')
// 						.find(`.swiper-slide`)
// 						.map(function() {
// 							return $(this).data('id');
// 						});

// 		hashSlide = arIds.toArray().indexOf(hash);

// 		if (hashSlide < 0) {
// 			hashSlide = 0;
// 		}
// 	}

// 	const teamSwiperList = new Swiper('.team', {
// 		spaceBetween: 22,
// 		simulateTouch: false,
// 		effect: 'fade',
// 		init: false,
// 		initialSlide: hashSlide,
// 		pagination: {
// 			el: '.swiper-pagination--team > .swiper-wrapper',
// 			clickable: true,
// 			type: 'bullets',
// 			renderBullet: function (index, className) {
// 				let $slide = $(this.slides[index]),
// 					$contentItem = $slide.find('.team__pagination-item').html();
// 				return `<div class="${className}"><div class="team__pagination-item">${$contentItem}</div></div>`;
// 			}
// 		},
// 		navigation: {
// 			nextEl: '.swiper-button-next--team',
// 			prevEl: '.swiper-button-prev--team',
// 		},
// 		on: {
// 			slideChange: function () {
// 				location.hash = this.slides[this.activeIndex].dataset.id;
// 			},
// 		}
// 	});

// 	teamSwiperList.on('init', function() {
// 		const teamSwiperListThumbs = new Swiper('.swiper-pagination--team', {
// 			spaceBetween: 0,
// 			simulateTouch: false,
// 			// centeredSlides: true,
// 			slidesPerView: 'auto',
// 			touchRatio: 0.2,
// 			slideToClickedSlide: true,
// 			slideClass: 'swiper-pagination-bullet',
// 			breakpoints: {
// 				520: {
// 					slidesPerView: 1,
// 				},
// 				768: {
// 					slidesPerView: 2,
// 				},
// 				1024: {
// 					slidesPerView: 3,
// 				}
// 			}
// 		});

// 		teamSwiperList.controller.control = teamSwiperListThumbs;
// 		teamSwiperListThumbs.controller.control = teamSwiperList;
// 	});

// 	teamSwiperList.init();
// }


// WEBPACK FOOTER //
// ./frontend/components/slider/slider.js